import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, NonIdealState } from '@blueprintjs/core';
import colors from 'utils/colors';
import {
  Container,
  Heading,
  Table,
  TableHeader,
  ViewWrapper,
  TableRow,
  TableData,
} from 'components/dashboard/components/styled-components';
import { HoverTableRow } from 'components/styled-components';
import { withRouter } from 'react-router';

const ReviewTable = ({ data, history }) => {
  if (data['result'] && data.totalCount !== 0) {
    return data['result'].slice(0, 5).map(item => (
      <HoverTableRow
        key={`${item.vendorRequestID}-${item.requestSubmittedDate}`}
        onClick={() => history.push(`/assessments/${item.vendorRequestID}`)}
      >
        <TableData border={`2pt solid ${colors.brandingPrimary}`}>
          <span style={{ color: colors.blue }}>
            {item.vendorInformation.vendorName || '[link to request]'}
          </span>
          <p>{item.productServiceName}</p>
        </TableData>
        <TableData border={`2pt solid ${colors.brandingPrimary}`}>
          {item.requestSubmittedDate}
        </TableData>
      </HoverTableRow>
    ));
  }
  return (
    <TableRow>
      <TableData colSpan={2}>
        <NonIdealState
          icon="info-sign"
          description={
            <>There are no Third Party Assessments for this filter.</>
          }
        />
      </TableData>
    </TableRow>
  );
};

const ReviewList = props => (
  <Container>
    <Heading>
      <Icon icon="issue" color="#FAB03C" iconSize={Icon.SIZE_LARGE} />
      {props.title}
    </Heading>
    <Table>
      <tbody>
        <TableRow>
          <TableHeader>Third Party Name &amp; Product or Service</TableHeader>
          <TableHeader>Date Created</TableHeader>
        </TableRow>
        <ReviewTable data={props.data} history={props.history} />
      </tbody>
    </Table>

    <NavLink
      to={{
        pathname: props.filter === 'upcoming' ? '/renewals' : '/assessments',
        filterType: props.filterType,
        filter: props.filter,
      }}
    >
      <ViewWrapper>View All ({props.data.totalCount || '0'})</ViewWrapper>
    </NavLink>
  </Container>
);

export default withRouter(ReviewList);
